import styled from 'styled-components';
import { FONTS, COLORS, SIZE } from '@app/src/ui';


export const Wrapper = styled.div`
  font-size: 14px;
  line-height: 24px;
  text-align: right;
  margin-top: 0;
  padding-right: 40px;
`;

export const Description = styled.ul`
  display: flex;
  flex-direction: column;
`;

export const Link = styled.a`
  color: ${COLORS.GRAY_PLACEHOLDER};
`;

export const Title = styled.h3`
  font-family: ${FONTS.OPEN_SANS};
  color: #fff;
  font-size: 13px;
  line-height: 15px;
  margin: 0 0 4px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    color: ${COLORS.BLACK};
  }
`;
